import { useQuery } from "@apollo/client"
import { FC } from "react"
import { gql } from "~/__generated__"
import { Tag } from "~/bookmarks/bookmark-index-screen"
import { GraphqlError } from "./errors"
import Pill from "./pill"

export interface FilteredTagListParams {
  filterTags?: Array<Tag>
  filterTagIds?: Array<string>
  toggleFilterTag: (tag: Tag) => void
}

const SELECTED_TAGS_QUERY = gql(/* GraphQL */ `
  query SelectedTags($selectedTagIds: [ID!]) {
    selectedTags: nodes(ids: $selectedTagIds) {
      __typename
      ... on Tag {
        id
        name
        slug
      }
    }
  }
`)

const FilteredTagList: FC<FilteredTagListParams> = ({
  filterTags,
  filterTagIds,
  toggleFilterTag,
}) => {
  const { data, error } = useQuery(SELECTED_TAGS_QUERY, {
    variables: { selectedTagIds: filterTagIds },
    skip: !filterTagIds || filterTagIds.length === 0,
  })

  const tagsFromIds =
    data?.selectedTags?.filter(
      (tag): tag is { __typename: "Tag"; id: string; name: string; slug: string } =>
        tag?.__typename === "Tag"
    ) || []

  // Use provided tags or tags fetched from IDs
  const tags = filterTags || tagsFromIds

  if (error) return <GraphqlError error={error} />

  if (!tags.length) {
    return null
  }

  return (
    <div className="mt-6 flex justify-start space-x-2">
      <span className="self-center text-xs text-gray-400">Tags Applied:</span>
      {tags.map((tag) => (
        <Pill key={tag.id} name={tag.name} onDelete={() => toggleFilterTag(tag)} />
      ))}
    </div>
  )
}

export default FilteredTagList
